import { render, staticRenderFns } from "./AdminTaskRow.vue?vue&type=template&id=6ab90312&scoped=true"
import script from "./AdminTaskRow.vue?vue&type=script&lang=js"
export * from "./AdminTaskRow.vue?vue&type=script&lang=js"
import style0 from "./AdminTaskRow.vue?vue&type=style&index=0&id=6ab90312&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ab90312",
  null
  
)

export default component.exports